import { useEffect, useState } from 'react'
import clientes from '../../api/clientes'
import { useToast } from '../../hooks/toast'
import Loader from '../Loader'
import * as S from './styles'

const ProfileGimba = ({ onChange, userData, refreshUserData, refresh }) => {
  // const [codigoPromotorMock, setCodigoPromotorMock] = useState('')
  const [current, setCurrent] = useState(true)
  const [loading, setLoading] = useState(false)
  const { addToast } = useToast()
  const { codigoPromotor } = userData

  useEffect(() => {
    refreshUserData(!refresh)
  }, [current])

  const handleClick = async (e) => {
    setLoading(true)

    await clientes
      .postPromotorVendas()
      .then((result) => {
        setLoading(false)

        //Successful request processing
        if (result.ok) {
          addToast({
            type: 'success',
            title: `Cadastrado como Promotor de Vendas`
          })
          setTimeout(() => {
            window.location.reload()
          }, 3000)
        } else if (result.status !== 200) {
          addToast({
            type: 'error',
            title: 'Problema ao cadastrar Promotor de Vendas'
          })
        }
        setCurrent(!current)
      })
      .catch((error) => {
        setLoading(false)
        error.json().then((body) => {
          addToast({ type: 'error', title: body.errors.Messages[0] })
        })
      })
  }
  return (
    <>
      {loading ? <Loader /> : null}
      <S.PerfilBox>
        <S.PerfilTitle>Promotor de Vendas</S.PerfilTitle>
        {current === true || current === false ? (
          <S.PerfilFormGroup>
            {codigoPromotor === '' ||
            codigoPromotor === null ||
            codigoPromotor === undefined ? (
              <>
                <S.PerfilInputCheck
                  onChange={(e) => onChange(e.target.checked, 'PromotorVendas')}
                  onClick={(e) => handleClick(e)}
                  checked={
                    codigoPromotor === '' ||
                    codigoPromotor === null ||
                    codigoPromotor === undefined
                      ? false
                      : true
                  }
                  type="checkbox"
                  name="PromotorVendas"
                  id="PromotorVendas"
                ></S.PerfilInputCheck>
                <S.PerfilLabel htmlFor="PromotorVendas">
                  Desejo me tornar Promotor de Vendas
                </S.PerfilLabel>
                <S.Leia
                  target="_blank"
                  href={`${process.env.REACT_APP_URL_MAIN}/promotor-de-vendas`}
                >
                  Leia o Regulamento
                </S.Leia>
              </>
            ) : (
              <>
                <p>
                  Seu Código de Promotor é <strong>{codigoPromotor}</strong>
                </p>
                <S.Leia
                  className="promotor"
                  target="_blank"
                  href={`${process.env.REACT_APP_URL_MAIN}/promotor-de-vendas`}
                >
                  Leia o Regulamento
                </S.Leia>
              </>
            )}
          </S.PerfilFormGroup>
        ) : null}
      </S.PerfilBox>
    </>
  )
}

export default ProfileGimba
